import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";

import styled, { withTheme } from "styled-components";

import moment from "moment";

import SmartFoodDrinkSelector from "../FoodDrinkSelector/FoodDrinkSelector";
import SmartDietDiaryCharts from "../Charts/DietDiaryCharts";
import DateAndTime from "../../ui-library/DateAndTime/DateAndTime/DateAndTime";
import CustomTabs, {
  CustomTabContent,
  TabButton,
} from "../../ui-library/CustomTabs/CustomTabs";

import NutritionTable from "../../library/NutritionTable/NutritionTable";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";

import AnimatedButton from "../../ui-library/Buttons/AnimatedButton/AnimatedButton";
import SecondaryButton from "../../ui-library/Buttons/SecondaryButton/SecondaryButton";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";

import {
  changeRequestReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./ChangeRequest.store";
import DailyTargets from "../../library/Goals/DailyTargets";
import LabelledInput from "../../ui-library/LabelledInput/LabelledInput";
import Checkbox from "../../ui-library/Checkbox/Checkbox";
import { scrollModalToTop } from "../../../modules/utils";
import {
  ChangeRequestStatus,
  dailyTargetIds,
  DateFormat,
  getMacronutrientColor,
  PIE_CHART_SERIES_ATTRS,
} from "../../../modules/constants";
import { GoalLevels } from "../../library/Goals/Constants";
import {
  addOtherSlice,
  calcKcalByAttrId,
  decimalPlaces,
  roundMealValue,
} from "../../../helpers/mealsHelper";
import { useTranslation } from "react-i18next";

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;

  @media (max-width: 991px) {
    margin-top: 1rem;
    justify-content: space-between;
    & > button {
      width: 100%;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const LeftColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  @media (max-width: 991px) {
    width: 100%;
  }
`;

const RightColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding-left: 25px;
  margin-top: 0;

  @media (max-width: 991px) {
    width: 100%;
    padding-left: 0;
    margin-top: 30px;
  }
`;

const DateAndTimeRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const DailyTargetsWrapper = styled.div`
  margin-top: 20px;
`;

const ReasonForChangeWrapper = styled.div`
  margin-top: 25px;
`;

const StyledCheckboxLabel = styled.div`
  font-weight: 600;
  margin-left: 15px;
  cursor: pointer;
`;

const StyledCheckboxWrapper = styled.div`
  display: flex;
  margin-top: 30px;
  margin-bottom: 15px;
`;

const ChangeToWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ChangeToDateTimeItem = styled.div`
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-right: 50px;
  }

  h6 {
    margin-bottom: 10px;
    font-weight: 700;
  }

  span.highlight {
    color: ${(props) => props?.theme?.lightGreen};
  }
`;

const ChangeToInfo = styled.span`
  margin-top: 30px;
  font-size: 16px;

  .highlight {
    color: ${(props) => props?.theme?.lightGreen};
  }
`;

export const SmartChangeRequest = (props) => {
  const {
    dailyTargets,
    nutritionalInfo,
    setNutritionalInfo,
    selectedItems,
    setSelectedItems,
    originalSelectedItems,
    setOriginalSelectedItems,
    calories,
    setCalories,
    chartsHelper,
    setChartsHelper,
    isSuccess,
    isError,
    setIsSuccess,
    setIsError,
    dateAndTimeValues,
    setDateAndTimeValues,
    originalDateAndTimeValues,
    setOriginalDateAndTimeValues,
    createChangeRequest,
    nutritionFields,
    fetchNutritionFields,
    setAboutMeal,
    aboutMeal,
    updateReasonFor,
    setUpdateReasonFor,
    resetStates,
    defaultItems,
    mealId,
    onSubmit,
    mealJsonData,
    minDate,
    maxDate,
    participantId,
    participantUsername,
    type,
    mealDate,
    setModalTitle,
    theme,
    studyId,
    entryMeal,
    changeRequest,
    readOnly,
    approveChangeRequest,
    declineChangeRequest,
    reasonForDecline,
    setReasonForDecline,
    participantLanguage,
  } = props;

  const { t } = useTranslation();

  const [updateReasonForIsValid, setUpdateReasonForIsValid] = useState(false);

  const [confirm, setConfirm] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [confirmingItems, setConfirmingItems] = useState(false);
  const [dateTimeError, setDateTimeError] = useState(false);
  const [reasonForChangeError, setReasonForChangeError] = useState(null);
  const [reasonForDeclineError, setReasonForDeclineError] = useState(null);

  const [tabActiveKey, setTabActiveKey] = useState("first");

  const [newItems, setNewItems] = useState([]);

  const btnSaveErrorMngmt = {
    isSuccess: isSuccess,
    setIsSuccess: setIsSuccess,
    isError: isError,
    setIsError: setIsError,
  };

  const handleConfirm = () => {
    if (!selectedItems || selectedItems.length === 0) {
      setIsError(true);
      sendNotification(
        "You need to add at least one food or drink item.",
        ToastType.ERROR
      );
      return;
    }

    const anyItemWithoutQty = selectedItems.some(
      (item) => !item.qty || parseFloat(item.qty) === 0
    );
    if (anyItemWithoutQty) {
      setIsError(true);
      sendNotification(
        "You need to specify the quantity for all items",
        ToastType.ERROR
      );
      return;
    }

    if (confirmingItems) {
      submitHandler();
    } else {
      calculateItemsDiff();
      scrollModalToTop();
      setConfirmingItems(true);
    }
  };

  const handleApprove = () => {
    approveChangeRequest(changeRequest.key)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        setIsSuccess(true);
        resetStates();
        onSubmit(true);
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
        setIsError(true);
      });
  };

  const handleDecline = () => {
    if (!validateReasonForDecline(reasonForDecline)) {
      setIsError(true);
      return;
    }

    declineChangeRequest(changeRequest.key, reasonForDecline)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        setIsSuccess(true);
        resetStates();
        onSubmit(true);
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
        setIsError(true);
      });
  };

  const calculateItemsDiff = useCallback(() => {
    const items = [];
    const addedItems = [];

    selectedItems.forEach((item) => {
      let oldItem = originalSelectedItems.find(
        (x) => x.title.toLowerCase() === item.title.toLowerCase()
      );

      if (!oldItem) {
        const newItem = {
          ...item,
          addedOrModified: true,
        };

        addedItems.push(newItem);
      } else {
        oldItem = originalSelectedItems.find(
          (x) =>
            x.title.toLowerCase() === item.title.toLowerCase() &&
            x.qty === item.qty &&
            x.selectedMeasure.measure === item.selectedMeasure.measure
        );

        if (!oldItem) {
          oldItem = {
            ...item,
            addedOrModified: true,
          };
        }

        items.push(oldItem);
      }
    });

    originalSelectedItems.forEach((item, index) => {
      const oldItem = selectedItems.find(
        (x) => x.title.toLowerCase() === item.title.toLowerCase()
      );

      if (!oldItem) {
        items.splice(index, 0, { ...item, removed: true });
      }
    });

    items.push(...addedItems);
    setNewItems(items);
  }, [originalSelectedItems, selectedItems]);

  useEffect(() => {
    if (setModalTitle) {
      if (readOnly && changeRequest) {
        setModalTitle(`${participantUsername} entry`);
      } else if (!readOnly && changeRequest) {
        setModalTitle(
          `${
            changeRequest.requestor
          } requested a change for ${participantUsername} on ${moment(
            changeRequest.mealDate
          ).format(DateFormat.BASE_FORMAT)}`
        );
      } else {
        if (confirmingItems) {
          setModalTitle(
            `Please review ${participantUsername} entry before submitting`
          );
        } else {
          setModalTitle(`Editing ${participantUsername} entry`);
        }
      }
    }
  }, [
    confirmingItems,
    setModalTitle,
    participantUsername,
    changeRequest,
    readOnly,
  ]);

  const getNutrientById = useCallback(
    (searchAttrId) => {
      const info = nutritionalInfo.find(
        ({ attr_id }) => attr_id === searchAttrId
      );

      return info;
    },
    [nutritionalInfo]
  );

  const getNutrientUnitById = useCallback(
    (searchAttrId) => {
      const info = getNutrientById(searchAttrId);

      return info ? info.unit : "";
    },
    [getNutrientById]
  );

  const dailyTargetsArr = useMemo(() => {
    return dailyTargets
      ? {
          goalTitle: "Daily Targets",
          goalsList: [
            {
              goalLabel: "Protein",
              goalLevel: GoalLevels.greaterOrEqual,
              goalColor: getMacronutrientColor(
                dailyTargetIds.PROTEIN_ATTR_ID,
                theme,
                studyId
              ),
              goalValue: `${roundMealValue(
                dailyTargets?.proteinPercentage ?? 0
              )}%`,
            },
            {
              goalLabel: "Carbohydrates",
              goalLevel: GoalLevels.less,
              goalColor: getMacronutrientColor(
                dailyTargetIds.CARBS_ATTR_ID,
                theme,
                studyId
              ),
              goalValue: `${roundMealValue(
                dailyTargets?.carbohydratesPercentage ?? 0
              )}%`,
            },
          ],
          goalMessage: "Minimal intake of simple sugars",
        }
      : null;
  }, [dailyTargets, theme, studyId]);

  const setupChartsHelper = useCallback(() => {
    const chartInfoVals = PIE_CHART_SERIES_ATTRS.map((searchAttrId) => {
      const nutrient = nutritionalInfo.find(
        ({ attr_id }) => attr_id === searchAttrId
      );
      const numericValue = nutrient?.numericValue ?? 0.0;
      const title = nutrient ? nutrient.chartTitle : "";
      const aboutMealLetter = nutrient ? nutrient.aboutMealLetter : "";
      const value = nutrient ? nutrient.value : "-";

      return {
        attr_id: searchAttrId,
        letter: title,
        aboutMealLetter: aboutMealLetter,
        numericValue: numericValue,
        value: value,
      };
    });

    const total = calories.numericValue || 1;

    const sugar = nutritionalInfo.find(
      ({ attr_id }) => attr_id === dailyTargetIds.SUGAR_ATTR_ID
    );
    const sugarTitle = sugar ? sugar.chartTitle : "";
    const sugarNumericValue = sugar?.numericValue ?? 0.0;

    const tmpVals = {};
    const chartVals = chartInfoVals.map((item) => {
      const frequency = roundMealValue(
        (calcKcalByAttrId(item.numericValue, item.attr_id) / total) * 100.0
      );

      tmpVals[item.aboutMealLetter] = {
        value: item.numericValue,
        percentage: frequency,
        unit: getNutrientUnitById(item.attr_id),
      };

      let subInfo = null;

      if (item.attr_id === dailyTargetIds.CARBS_ATTR_ID) {
        subInfo = `(${sugarTitle}: ${roundMealValue(sugarNumericValue).toFixed(
          decimalPlaces
        )}g)`;

        tmpVals[sugarTitle] = {
          value: roundMealValue(sugarNumericValue),
          unit: getNutrientUnitById(dailyTargetIds.SUGAR_ATTR_ID),
        };
      }

      return {
        letter: item.letter,
        frequency: frequency,
        color: getMacronutrientColor(item.attr_id, theme, studyId),
        percentage: `${Number(frequency).toFixed(decimalPlaces)}%`,
        info: `${Number(frequency).toFixed(decimalPlaces)}% - ${item.value}`,
        subInfo: subInfo,
        isVisible: true,
      };
    });

    chartVals && chartVals.push(addOtherSlice(chartVals, theme, studyId, t));

    setChartsHelper({
      pieChartSeries: chartVals,
      hpbcImpact: tmpVals,
    });

    setAboutMeal(tmpVals);
  }, [
    nutritionalInfo,
    setChartsHelper,
    setAboutMeal,
    getNutrientUnitById,
    theme,
    studyId,
    calories.numericValue,
    t,
  ]);

  useEffect(() => {
    const tmpCalories = nutritionalInfo.find(
      ({ attr_id }) => attr_id === dailyTargetIds.CALORIES_ATTR_ID
    );
    if (tmpCalories) {
      setCalories({
        percentage: 0,
        value: tmpCalories.value,
        numericValue: tmpCalories.numericValue,
        unit: getNutrientUnitById(dailyTargetIds.CALORIES_ATTR_ID),
      });
    }

    setupChartsHelper();
  }, [nutritionalInfo, setCalories, setupChartsHelper, getNutrientUnitById]);

  const validateReasonForChange = (reason) => {
    if (reason.replace(/\.|,/g, "").trim() === "") {
      setReasonForChangeError("Please provide a reason");
      setUpdateReasonForIsValid(false);
    } else if (reason.length > 450) {
      setReasonForChangeError(
        "Please enter a reason with less than 450 characters"
      );
      setUpdateReasonForIsValid(false);
    } else {
      setReasonForChangeError(null);
      setUpdateReasonForIsValid(true);
    }
  };

  useEffect(() => {
    if (updateReasonFor.replace(/\.|,/g, "").trim() !== "") {
      validateReasonForChange(updateReasonFor);
    }
  }, [updateReasonFor]);

  const backHandler = () => {
    if (readOnly) {
      onSubmit();
    } else {
      scrollModalToTop();
      setConfirm(false);
      setConfirmingItems(false);
      setUpdateReasonFor("");
      setUpdateReasonForIsValid(false);
      setReasonForChangeError(null);
    }
  };

  const validateReasonForDecline = (reason) => {
    if (reason.replace(/\.|,/g, "").trim() === "") {
      setReasonForDeclineError("Please provide a reason");
      return false;
    } else if (reason.length > 450) {
      setReasonForDeclineError(
        "Please enter a reason with less than 450 characters"
      );
      return false;
    } else {
      setReasonForDeclineError(null);
      return true;
    }
  };

  const submitHandler = useCallback(() => {
    const date = moment(dateAndTimeValues.dateAndTimeObj.eventDate);
    const timeValue = moment(dateAndTimeValues.dateAndTimeObj.eventTime)
      .format("HH:mm")
      .split(":");
    date.set({
      h: timeValue[0],
      m: timeValue[1],
    });

    const tmpAboutMeal = aboutMeal;

    tmpAboutMeal["Calories"] = {
      percentage: 0,
      value: calories.numericValue,
      unit: calories.unit,
    };

    const mealJson = {
      aboutMeal: tmpAboutMeal,
      items: selectedItems,
      type: type,
    };

    const formData = {
      mealDate: date.format(DateFormat.EXTENDED_DATETIME),
      mealJson: JSON.stringify(mealJson),
    };

    formData.participantID = participantId;

    if (updateReasonForIsValid) {
      formData.mealID = mealId;
      formData.reasonForChange = updateReasonFor;
    } else {
      setUpdateReasonForIsValid(false);
      validateReasonForChange(updateReasonFor);
      setIsError(true);
      return;
    }

    createChangeRequest(formData)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        setIsSuccess(true);
        resetStates();
        onSubmit(true);
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
        setIsError(true);
      });
  }, [
    dateAndTimeValues,
    aboutMeal,
    calories,
    selectedItems,
    type,
    participantId,
    updateReasonForIsValid,
    createChangeRequest,
    mealId,
    updateReasonFor,
    setIsError,
    setIsSuccess,
    resetStates,
    onSubmit,
  ]);

  useEffect(() => {
    return () => {
      resetStates();
    };
  }, [resetStates]);

  useEffect(() => {
    setStartDate(dateAndTimeValues?.dateAndTimeObj?.eventDate ?? new Date());
  }, [dateAndTimeValues]);

  useEffect(() => {
    if (mealJsonData) {
      const mealData = JSON.parse(mealJsonData);
      setAboutMeal(mealData?.aboutMeal);
      setSelectedItems(mealData?.items);
      setOriginalSelectedItems(mealData?.items);
    }
  }, [mealJsonData, setAboutMeal, setOriginalSelectedItems, setSelectedItems]);

  const onChangeDate = useCallback(
    (isDateAndTimeValid, dateAndTimeObj) => {
      setDateAndTimeValues({
        isValid: isDateAndTimeValid,
        dateAndTimeObj,
      });
    },
    [setDateAndTimeValues]
  );

  useEffect(() => {
    if (changeRequest) {
      setUpdateReasonFor(changeRequest.reasonForChange);
      const originalMealJson = JSON.parse(changeRequest.originalMealJson);
      setOriginalSelectedItems(originalMealJson?.items);

      const mealJson = JSON.parse(changeRequest.mealJson);
      setSelectedItems(mealJson?.items);
      setAboutMeal(mealJson?.aboutMeal);

      onChangeDate(true, {
        eventDate: moment(changeRequest.mealDate).toDate(),
        eventTime: moment(changeRequest.mealDate).toDate(),
      });

      setOriginalDateAndTimeValues({
        isValid: true,
        dateAndTimeObj: {
          eventDate: moment(changeRequest.originalMealDate).toDate(),
          eventTime: moment(changeRequest.originalMealDate).toDate(),
        },
      });

      setConfirmingItems(true);
    }
  }, [
    changeRequest,
    onChangeDate,
    setAboutMeal,
    setOriginalDateAndTimeValues,
    setOriginalSelectedItems,
    setSelectedItems,
    setUpdateReasonFor,
  ]);

  useEffect(() => {
    if (selectedItems && originalSelectedItems && changeRequest) {
      calculateItemsDiff();
    }
  }, [selectedItems, originalSelectedItems, calculateItemsDiff, changeRequest]);

  useEffect(() => {
    if (mealDate) {
      onChangeDate(true, {
        eventDate: moment(mealDate).toDate(),
        eventTime: moment(mealDate).toDate(),
      });

      setOriginalDateAndTimeValues({
        isValid: true,
        dateAndTimeObj: {
          eventDate: moment(mealDate).toDate(),
          eventTime: moment(mealDate).toDate(),
        },
      });
    }
  }, [mealDate, onChangeDate, setOriginalDateAndTimeValues]);

  const handleKeyPressCheckbox = (e) => {
    if (e.key === "Enter") {
      setConfirm((prevState) => !prevState);
    }
  };

  const tableHeaders = [{ label: "Description" }, { label: "Quantity" }];

  const dateClassName = "date-select-wrapper mr-4";
  const timeClassName = "time-wrapper";

  const isHighlighted = (oldDateTime, newDateTime) => {
    return oldDateTime !== newDateTime ? "highlight" : null;
  };

  return (
    <Container data-testid="change-request">
      <Row>
        <LeftColWrapper>
          {confirmingItems ? (
            <SmartFoodDrinkSelector
              selectedItems={originalSelectedItems}
              readOnly={true}
              participantLanguage={participantLanguage}
              title={
                changeRequest
                  ? `Original - ${moment(changeRequest.originalMealDate).format(
                      DateFormat.BASE_FORMAT
                    )}`
                  : "Original"
              }
            />
          ) : (
            <SmartFoodDrinkSelector
              defaultItems={defaultItems}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
              readOnly={confirmingItems}
              inputTitle="Add new item"
              participantLanguage={participantLanguage}
            />
          )}

          <DateAndTimeRowWrapper>
            <DateAndTime
              onChange={onChangeDate}
              maxDate={maxDate}
              minDate={minDate}
              readOnly={confirmingItems}
              defaultDate={
                confirmingItems
                  ? originalDateAndTimeValues?.dateAndTimeObj?.eventDate
                  : dateAndTimeValues?.dateAndTimeObj?.eventDate
              }
              defaultTime={
                confirmingItems
                  ? originalDateAndTimeValues?.dateAndTimeObj?.eventTime
                  : dateAndTimeValues?.dateAndTimeObj?.eventTime
              }
              onError={setDateTimeError}
              timeIntervals={5}
              {...{ dateClassName }}
              {...{ timeClassName }}
            />
          </DateAndTimeRowWrapper>

          {dailyTargetsArr && (
            <DailyTargetsWrapper>
              <DailyTargets {...dailyTargetsArr} />
            </DailyTargetsWrapper>
          )}
        </LeftColWrapper>
        <RightColWrapper>
          {confirmingItems ? (
            <ChangeToWrapper>
              <SmartFoodDrinkSelector
                selectedItems={newItems}
                readOnly={true}
                title="Change to"
                participantLanguage={participantLanguage}
              />

              <DateAndTimeRowWrapper>
                <ChangeToDateTimeItem>
                  <h6>Date:</h6>

                  <span
                    className={isHighlighted(
                      moment(
                        originalDateAndTimeValues?.dateAndTimeObj?.eventDate
                      ).format(DateFormat.BASE_FORMAT),
                      moment(
                        dateAndTimeValues?.dateAndTimeObj?.eventDate
                      )?.format(DateFormat.BASE_FORMAT)
                    )}
                  >
                    {moment(
                      dateAndTimeValues?.dateAndTimeObj?.eventDate
                    ).format(DateFormat.BASE_FORMAT)}
                  </span>
                </ChangeToDateTimeItem>
                <ChangeToDateTimeItem>
                  <h6>Time:</h6>
                  <span
                    className={isHighlighted(
                      moment(
                        originalDateAndTimeValues?.dateAndTimeObj?.eventTime
                      ).format("LT"),
                      moment(
                        dateAndTimeValues?.dateAndTimeObj?.eventTime
                      )?.format("LT")
                    )}
                  >
                    {moment(
                      dateAndTimeValues?.dateAndTimeObj?.eventTime
                    ).format("LT")}
                  </span>
                </ChangeToDateTimeItem>
              </DateAndTimeRowWrapper>

              <ChangeToInfo>
                Please look at{" "}
                <span className="highlight">&#x25A2;modified/added</span> items.
              </ChangeToInfo>
            </ChangeToWrapper>
          ) : (
            <CustomTabs
              defaultActiveKey="first"
              onSelect={(eventKey) => {
                setTabActiveKey(eventKey);
              }}
            >
              <TabButton eventKey="first">About this Meal</TabButton>
              <TabButton eventKey="second">Nutrition Details</TabButton>
              <CustomTabContent eventKey="first">
                {selectedItems.length > 0 && (
                  <SmartDietDiaryCharts
                    participantId={participantId}
                    constants={dailyTargetIds}
                    getNutrientById={getNutrientById}
                    calories={calories}
                    pieChartSeries={chartsHelper.pieChartSeries.filter(
                      (item) => item.frequency > 0
                    )}
                    hpbcImpact={chartsHelper.hpbcImpact}
                    startDate={startDate}
                    getMacronutrientColor={getMacronutrientColor}
                    mealId={mealId}
                    studyId={studyId}
                    rerenderPieChart={tabActiveKey === "first"}
                  />
                )}
              </CustomTabContent>
              <CustomTabContent eventKey="second">
                <NutritionTable
                  nutritionalInfo={nutritionalInfo}
                  setNutritionalInfo={setNutritionalInfo}
                  nutritionFields={nutritionFields}
                  fetchNutritionFields={fetchNutritionFields}
                  selectedItems={selectedItems}
                  tableHeaders={tableHeaders}
                />
              </CustomTabContent>
            </CustomTabs>
          )}

          {changeRequest && updateReasonFor && (
            <ReasonForChangeWrapper>
              <LabelledInput
                title="Reason for change:"
                type="text"
                data-testid="update-reason-input"
                value={updateReasonFor}
                disabled={true}
              />
            </ReasonForChangeWrapper>
          )}

          {mealId && confirmingItems && !changeRequest && (
            <ReasonForChangeWrapper>
              <LabelledInput
                title="Reason for change:"
                type="text"
                data-testid="update-reason-input"
                onBlur={(e) => validateReasonForChange(e.target.value)}
                hasError={!!reasonForChangeError}
                errorMessage={reasonForChangeError}
                value={updateReasonFor}
                onChange={(e) => setUpdateReasonFor(e.target.value)}
              />
            </ReasonForChangeWrapper>
          )}

          {changeRequest &&
            readOnly &&
            !!changeRequest.reasonForDecline &&
            changeRequest.status === ChangeRequestStatus.DECLINED.id && (
              <ReasonForChangeWrapper>
                <LabelledInput
                  title="Reason for decline:"
                  data-testid="reason-decline-input"
                  type="text"
                  value={changeRequest.reasonForDecline}
                  disabled={true}
                />
              </ReasonForChangeWrapper>
            )}

          {changeRequest &&
            changeRequest.status === ChangeRequestStatus.OPEN.id &&
            !readOnly && (
              <ReasonForChangeWrapper>
                <LabelledInput
                  title="Reason for decline:"
                  type="text"
                  data-testid="reason-decline-input"
                  hasError={!!reasonForDeclineError}
                  errorMessage={reasonForDeclineError}
                  value={reasonForDecline}
                  onChange={(e) => setReasonForDecline(e.target.value)}
                />
              </ReasonForChangeWrapper>
            )}

          {confirmingItems && !changeRequest && (
            <StyledCheckboxWrapper
              tabIndex="0"
              onKeyPress={handleKeyPressCheckbox}
            >
              <Checkbox
                data-testid="confirm-checkbox"
                checked={confirm}
                onClick={() => setConfirm((prevState) => !prevState)}
                icon={true}
                square={true}
              />
              <StyledCheckboxLabel
                data-testid="confirm-checkbox-label"
                onClick={() => setConfirm((prevState) => !prevState)}
              >
                I confirm that the data change conversation has been logged in
                the subject's study chart.
              </StyledCheckboxLabel>
            </StyledCheckboxWrapper>
          )}
        </RightColWrapper>
      </Row>

      {(entryMeal || changeRequest) && (
        <ActionButtonsContainer>
          {confirmingItems && !changeRequest && (
            <SecondaryButton
              data-testid="back-button"
              className="mr-3"
              onClick={() => backHandler()}
            >
              Back
            </SecondaryButton>
          )}

          {readOnly && changeRequest && (
            <PrimaryButton
              data-testid="close-button"
              onClick={() => backHandler()}
            >
              Close
            </PrimaryButton>
          )}

          {!readOnly && changeRequest && (
            <>
              <AnimatedButton
                variant="secondary"
                className="mr-3"
                icon={null}
                onClick={() => handleDecline()}
                {...btnSaveErrorMngmt}
              >
                Decline
              </AnimatedButton>

              <AnimatedButton
                icon={null}
                onClick={() => handleApprove()}
                {...btnSaveErrorMngmt}
              >
                Approve
              </AnimatedButton>
            </>
          )}

          {readOnly || changeRequest ? (
            <div></div>
          ) : confirmingItems ? (
            <AnimatedButton
              data-testid="submit-button"
              icon={null}
              onClick={() => handleConfirm()}
              disabled={
                !confirm || reasonForChangeError || !updateReasonForIsValid
              }
              keepBorder={true}
              {...btnSaveErrorMngmt}
            >
              Request Change
            </AnimatedButton>
          ) : (
            <PrimaryButton
              data-testid="next-button"
              disabled={dateTimeError}
              onClick={() => handleConfirm()}
            >
              Next
            </PrimaryButton>
          )}
        </ActionButtonsContainer>
      )}
    </Container>
  );
};

export default dynamic(
  "changeRequestReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => {
      return {
        loginReducer: state.loginReducer,
        dietDiaryChartsReducer:
          state.changeRequestReducer.dietDiaryChartsReducer,
      };
    },
  }),
  attachReducer(changeRequestReducer)
)(connect(mapStateToProps, mapDispatchToProps)(withTheme(SmartChangeRequest)));
